import type { RequestOptions } from '../api';

/**
 * Builds the request options that carry the caller's app mode to the v3 API.
 *
 * Every v3 endpoint is gated by `verify_app_mode!` (inherited from the v3
 * `BaseApiController`), so app mode must accompany every request. The backend
 * resolves it from the `Jane-App-Mode` header (its preferred transport over the
 * legacy `app_mode` param/body), so all v3 data-access calls send it this way.
 */
export const appModeHeader = (appMode: string): RequestOptions => ({
  headers: { 'Jane-App-Mode': appMode },
});
